import '@babel/polyfill'
import 'isomorphic-fetch'

if (!ON_SERVER) {
    require('pepjs')
}
